import React from "react";
import LoadingSpin from "../../components/LoadingSpin";
import {BrowserRouter as Router, Link, Redirect} from "react-router-dom";
import Helmet from "react-helmet";
import ErrorMessage from "../../components/ErrorMessage";
import {config} from "../../components/Constants";
import DefaultAvatar from "../../../assets/images/avatar.png";
import SearchBar from "../../components/SearchBar";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Col, Container, Row} from "react-bootstrap";
import {faEdit, faTrashAlt, faUserPlus} from "@fortawesome/free-solid-svg-icons";

class UsersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            isLoggedIn: false,
            isSearching: false,
            removeUser: null,
            loggedUser: props.user,
            redirect: null,
            users: [],
            privileges: {}
        };
        this.removeUser = this.removeUser.bind(this);
    }

    removeUser(event, id) {
        if (event && event.preventDefault) {
            event.preventDefault();
            id = event.target.getAttribute('id');
        }
        this.setState({
            removeUser: id
        });
        return false;
    }

    componentDidMount() {
        fetch(config.API_URL + '/api/users', {
            credentials: 'include'
        })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result.error) {
                        this.setState({
                            users: [],
                            isLoaded: true,
                            error: result.error
                        });
                    } else if (result) {
                        let privileges = {};
                        for (let x = 0; x < result.privileges.length; x++) {
                            privileges[result.privileges[x].id] = result.privileges[x];
                        }
                        console.log(privileges);
                        this.setState({
                            users: result.users,
                            privileges: privileges,
                            isLoaded: true
                        });
                    }
                },
                (error) => {
                    this.setState({
                        users: [],
                        isLoaded: true,
                        error: error
                    });
                }
            )
    }

    render() {
        const {error, isLoaded, isLoggedIn, users, privileges, loggedUser, removeUser, redirect} = this.state;
        const that = this;
        if (redirect !== null) {
            return <Redirect to={redirect}/>
        } else if (!isLoaded) {
            return (
                <LoadingSpin/>
            );
        } else if (error) {
            return (
                <ErrorMessage title="Pojawiły się błędy" text={error} buttons={[
                    {
                        'title': 'Powrót', 'callback': function () {
                            that.setState({redirect: '/users', error: null});
                        }
                    }
                ]} handleClose={() => {
                    that.setState({redirect: '/users', error: null});
                }}/>
            );
        } else if (removeUser) {
            return (
                <ErrorMessage title="Usuwanie użytkownika" text="Czy na pewno chcesz usunąć tego użytkownika?" buttons={[
                    {
                        'title': 'Tak', 'callback': function () {
                            that.setState({
                                isLoaded: false
                            });
                            fetch(config.API_URL + '/api/users/delete', {
                                credentials: 'include',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                'method': 'POST',
                                'body': JSON.stringify({id: removeUser})
                            })
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                        if (result.error) {
                                            that.setState({
                                                isLoaded: true,
                                                error: result.error
                                            });
                                        } else if (result) {
                                            that.setState({
                                                redirect: '/users',
                                                isLoaded: true
                                            });
                                        }
                                    },
                                    (error) => {
                                        that.setState({
                                            isLoaded: true,
                                            error: error
                                        });
                                    }
                                );
                        }
                    },
                    {
                        'title': 'Nie', 'callback': function () {
                            that.setState({removeUser: null, error: null});
                        }
                    }
                ]} handleClose={() => {
                    that.setState({removeUser: null, error: null});
                }}/>
            );
        } else {
            return (
                <React.Fragment>
                    <Helmet>
                        <title>Administratorzy</title>
                    </Helmet>
                    <header className="clients-header">
                        <h1>Administratorzy</h1>
                        <Row>
                            <Col sm={12}>
                                <Link to={'/users/edit'}><Button><FontAwesomeIcon icon={faUserPlus}/> Dodaj użytkownika</Button></Link>
                            </Col>
                        </Row>
                    </header>
                    <div className="section-div">
                        <table className="data">
                            <thead id="tableHead">
                            <tr>
                                <th colSpan={2}>Użytkownik</th>
                                <th>ID</th>
                                <th>E-Mail</th>
                                <th>Uprawnienia</th>
                                <th className="center" colSpan="2">Akcje</th>
                            </tr>
                            </thead>
                            <tbody>
                            {users.map((user, mkey) => {
                                return (
                                    <tr key={mkey}>
                                        <td><img src={user.avatarImage ? user.avatarImage : DefaultAvatar} className="usertable-avatar"/></td>
                                        <td>{user.name} {user.surname}</td>
                                        <td>{user.id}</td>
                                        <td><a href={"mailto:" + user.email}>{user.email}</a></td>
                                        <td>{privileges[user.privileges_id].name}</td>
                                        <td className="center actions">
                                            <Link to={'/users/edit/' + user.id}>
                                                <FontAwesomeIcon icon={faEdit} title="Edytuj" />
                                            </Link>
                                        </td>
                                        <td className="center actions">
                                            {
                                                (user.id == loggedUser.id) ?
                                                    <del>
                                                        <FontAwesomeIcon icon={faTrashAlt} title="Usuń" />
                                                    </del> :
                                                    <a href="#" onClick={this.removeUser} data-id={user.id}>
                                                        <FontAwesomeIcon icon={faTrashAlt} title="Usuń" id={user.id} />
                                                    </a>
                                            }
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            );
        }
    }
}

export default UsersList;
